import { Component, Input } from '@angular/core';
import { Report } from '../../../models/report.model';

@Component({
  selector: 'app-expert-immobilier-read-mode',
  templateUrl: './expert-immobilier-read-mode.component.html',
  styleUrls: ['./expert-immobilier-read-mode.component.scss'],
})
export class ExpertImmobilierReadModeComponent {
  @Input() expert!: Report.Expert;
  @Input() exportPhoto!: string | undefined;
}
